import React from 'react';
import makeStyles from 'shared/makeStyles';
import PlayfulBlobs from './PlayfulBlobs';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // Allow rendering in tests that do not mount a ThemeProvider.
    padding:
      theme && typeof (theme as any).spacing === 'function'
        ? (theme as any).spacing(2)
        : 16,
  },
}));

export default function SmoothLoadingIndicator(props: {
  size?: number
  label?: string
}) {
  const classes = useStyles(props);
  return (
    <div
      className={classes.root}
      role="progressbar"
      aria-label={props.label || 'Loading'}
    >
      <PlayfulBlobs size={props.size || 180} animated />
    </div>
  );
}
